import { InstrumentBrand, InstrumentIcon } from '@foundation/apis/payments';

export function mapBrandNameToInstrumentBrand(
  brandName: string,
): InstrumentBrand | undefined {
  switch (brandName) {
    case 'amex':
    case 'american-express':
    case 'american express':
      return InstrumentBrand.Amex;
    case 'diners':
    case 'diners-club':
    case 'diners club':
      return InstrumentBrand.Diners;
    case 'discover':
      return InstrumentBrand.Discover;
    case 'elo':
      return InstrumentBrand.Elo;
    case 'jcb':
      return InstrumentBrand.Jcb;
    case 'mastercard':
    case 'master-card':
    case 'master_card':
    case 'ecmc':
      return InstrumentBrand.MasterCard;
    case 'maestro':
    case 'uk_maestro':
      return InstrumentBrand.Maestro;
    case 'unionpay':
    case 'union_pay':
    case 'china_union_pay':
      return InstrumentBrand.UnionPay;
    case 'visa':
      return InstrumentBrand.Visa;
    default:
      return undefined;
  }
}

export function getCardIcon(cardBrand: string) {
  switch (mapBrandNameToInstrumentBrand(cardBrand)) {
    case InstrumentBrand.Amex:
      return InstrumentIcon.Amex;
    case InstrumentBrand.Diners:
      return InstrumentIcon.Diners;
    case InstrumentBrand.Discover:
      return InstrumentIcon.Discover;
    case InstrumentBrand.Elo:
      return InstrumentIcon.Elo;
    case InstrumentBrand.Jcb:
      return InstrumentIcon.Jcb;
    case InstrumentBrand.MasterCard:
      return InstrumentIcon.MasterCard;
    case InstrumentBrand.Maestro:
      return InstrumentIcon.Maestro;
    case InstrumentBrand.UnionPay:
      return InstrumentIcon.UnionPay;
    case InstrumentBrand.Visa:
      return InstrumentIcon.Visa;
    default:
      return InstrumentIcon.GenericCard;
  }
}
